<template>
  <div class="pa-6">
    <div class="mb-6">
      <h2 class="text-h5 font-weight-bold mb-2">Appearance</h2>
      <p class="text-grey-darken-1">Customize your theme and language preferences</p>
    </div>

    <v-form>
      <div class="mb-6">
        <v-select
          v-model="currentTheme"
          label="Theme"
          variant="outlined"
          density="comfortable"
          prepend-inner-icon="far fa-palette"
          :items="themeItems"
          class="mb-4"
        />
      </div>
    </v-form>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useUserSettings } from "@/lib/userSettings";

const { t } = useI18n();

const {
  currentTheme,
  themeItems
} = useUserSettings();

const dark = t("components.UserSettingsPage.dark");
const light = t("components.UserSettingsPage.light");

// Iterate through themeItems and translate the titles
themeItems.forEach((item) => {
  if (item.title === "Dark") {
    item.title = dark;
  } else if (item.title === "Light") {
    item.title = light;
  }
});

</script>
